var map = {
	"./template.bet575": 1662,
	"./template.bet575.tsx": 1662,
	"./template.bet777": 2095,
	"./template.bet777.tsx": 2095,
	"./template.betbetbet": 2096,
	"./template.betbetbet.tsx": 2096,
	"./template.betgalaxy": 2097,
	"./template.betgalaxy.tsx": 2097,
	"./template.betprofessor": 2010,
	"./template.betprofessor.tsx": 2010,
	"./template.betroyale": 2098,
	"./template.betroyale.tsx": 2098,
	"./template.betstride": 2099,
	"./template.betstride.tsx": 2099,
	"./template.buffalobet": 2100,
	"./template.buffalobet.tsx": 2100,
	"./template.chromabet": 2101,
	"./template.chromabet.tsx": 2101,
	"./template.default": 676,
	"./template.default.tsx": 676,
	"./template.epicodds": 2102,
	"./template.epicodds.tsx": 2102,
	"./template.fiestabet": 2011,
	"./template.fiestabet.tsx": 2011,
	"./template.forsport": 1663,
	"./template.forsport.tsx": 1663,
	"./template.gigabet": 2103,
	"./template.gigabet.tsx": 2103,
	"./template.goldenbet888": 1664,
	"./template.goldenbet888.tsx": 1664,
	"./template.goldenrush": 2104,
	"./template.goldenrush.tsx": 2104,
	"./template.hyperbet": 2105,
	"./template.hyperbet.tsx": 2105,
	"./template.juicybet": 1665,
	"./template.juicybet.tsx": 1665,
	"./template.junglebet": 1666,
	"./template.junglebet.tsx": 1666,
	"./template.magnumbet": 2106,
	"./template.magnumbet.tsx": 2106,
	"./template.oldgill": 1667,
	"./template.oldgill.tsx": 1667,
	"./template.puntcity": 1668,
	"./template.puntcity.tsx": 1668,
	"./template.puntgenie": 2107,
	"./template.puntgenie.tsx": 2107,
	"./template.pyramidbet": 2108,
	"./template.pyramidbet.tsx": 2108,
	"./template.questbet": 1669,
	"./template.questbet.tsx": 1669,
	"./template.slambet": 2012,
	"./template.slambet.tsx": 2012,
	"./template.sterlingparker": 2013,
	"./template.sterlingparker.tsx": 2013,
	"./template.sugarcastle": 2109,
	"./template.sugarcastle.tsx": 2109,
	"./template.templebet": 2110,
	"./template.templebet.tsx": 2110,
	"./template.titanbet": 2111,
	"./template.titanbet.tsx": 2111,
	"./template.ts": 89,
	"./template.vikingbet": 1670,
	"./template.vikingbet.tsx": 1670,
	"./template.volcanobet": 2112,
	"./template.volcanobet.tsx": 2112,
	"./template.wellbet": 1671,
	"./template.wellbet.tsx": 1671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2470;